<template>
    <div class="modal fade" :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body modal-scroll  modal-text-center">
                    <img style="width: 400px;" :src="deckImage">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BookingDeckPopup",
    props: {
        isShow: {
            type: Boolean
        },
        shipCode: {
            type: String
        },
        sailDate: {
            type: String
        },
        deckNumber: {
            type: String
        },
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    computed: {
        deckImage() {
            const imgUrl = process.env.VUE_APP_IMG_URL;
            if (!this.shipCode || this.shipCode.length == 0 || !this.deckNumber || this.deckNumber.length == 0) {
                return ''
            }
            let image = `${imgUrl}/DeckImages/${this.shipCode}${this.deckNumber}.jpg`
            // 2021SC, 2019QN特殊图片
            const sailDateTime = new Date(this.sailDate)
            if (this.shipCode == 'SC') {
              image = `${imgUrl}/DeckImages/${this.shipCode}${this.deckNumber}.jpg`
            } else if(this.shipCode == 'OV') {
              image = `${imgUrl}/DeckImages/2024/${this.shipCode}${this.deckNumber}.jpg`
            } else if (this.shipCode == 'QN' && sailDateTime.getTime() >= new Date('2019-01-01').getTime()) {
              image = `${imgUrl}/DeckImages/${this.shipCode}2019${this.deckNumber}.jpg`
            }
            console.log(image)
            return image
        },
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>
.modal-body {
    padding: 20px;
    text-align: center;
    max-height: 700px;
    overflow: scroll;
}
.modal-dialog {
    top: 5%;

}

.modal {
    .common-modal-close {
        position: absolute;
        width: 28px;
        top: 3px;
        right: 5px;
        z-index: 2;
        cursor: pointer;
    }
}

.modal.active {
    display: block;
    overflow-x: hidden;
    overflow-y: scroll;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>
